import { Typography } from "@material-ui/core";
import { FC } from "react";

const PackageFees: FC<any> = (props) => {
  return <Typography variant="body2">{props.record.package.fees}</Typography>;
};

export default PackageFees;
